import { TDatabaseId } from '@infotech-soe/metaschema';

import UniqueId from '../../uid/UniqueId';

import CategoryLayoutViewModel from './CategoryLayoutViewModel';
import CategoryViewModelSource from './CategoryViewModelSource';
import DatasetViewModel from './DatasetViewModel';

export enum CategoryTreeType {
  NONE = 'none',
  CATALOGS = 'catalogs',
  HIERARCHY = 'hierarchy',
}

/**
 * View model of an open category.
 */
interface CategoryViewModel {
  /**
   * Unique ID.
   */
  id: UniqueId;

  /**
   * Initial request that was issued to open the category.
   */
  source: CategoryViewModelSource;

  /**
   * Datasets view models.
   */
  datasets: Record<UniqueId, DatasetViewModel>;

  /**
   * Visual layout description.
   */
  layout: CategoryLayoutViewModel;

  /**
   * Whether the category has a tree dataset, and what type it is.
   */
  treeType: CategoryTreeType;

  /**
   * Localized category title.
   */
  title: string;

  /**
   * Process id.
   */
  processId: TDatabaseId;
}

export default CategoryViewModel;
